export const CAPITALIZE_REGEX = /.*[A-Z].*/;
export const LOWERCASE_REGEX = /.*[a-z].*/;
export const NUMBER_REGEX = /.*[0-9].*/;
export const NUMBER_WITHOUT_FULL_WIDTH_REGEX = /^[^０-９]*$/;
export const SYMBOL_REGEX = /.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?].*/;
export const JAPAN_FULL_WIDTH_REGEX = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]|^$/;
export const EXCEPT_HIRAGANA_REGEX = /^[^\u3040-\u309F]*$/;
export const JAPANESE_REGEX =
  /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/;
export const HIRAGANA_KATAKANA_REGEX = /^[\u3040-\u309F\u30A0-\u30FF]+$/;
export const URL_REGEX =
  /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

export const PLATFORM_TYPE = {
  AGENT: 1,
  DIRECT: 7,
  BOTH: 8,
};

export const PLATFORM_CODE = {
  AGENT: 'agent',
  DIRECT: 'direct',
  BOTH: 'both',
} as const;
export type PlatformCode = (typeof PLATFORM_CODE)[keyof typeof PLATFORM_CODE];
export const EEASY_URL = 'https://aim-factory.eeasy.jp/se-navi';
export const MAX_UPLOAD_FILE_SIZE_MB = 1;

// メンテナンス関連の定数
export const MAINTENANCE_MESSAGE = {
  ADDITIONAL_INFO: 'ご迷惑をおかけいたしますが、ご理解の程よろしくお願いいたします。',
};
